const debug = Boolean(document.head.querySelector('meta[name="debug"]')?.content)
const appsignalKey = document.head.querySelector('meta[name="appsignal:key"]')?.content
const appsignalRevision = document.head.querySelector('meta[name="appsignal:revision"]')?.content

export { debug, appsignalKey, appsignalRevision }
